/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PatientPrescriptionsAllTabAliases {
  CONTEXTUAL_BAR = 'contextual-bar',
  DATE_PICKER_DATE = 'date-picker-date',
  FIELD_ADDITIONAL_HOURS = 'field-additional-hours',
  FIELD_PREVIOUS_HOURS = 'field-previous-hours',
  FILTER_FIELD_DATE = 'filter-field-date',
  FILTER_PRESCRIPTIONS = 'filter-prescriptions',
  FILTERED_LIST = 'filtered-list',
  INPUT_ADDITIONAL_HOURS = 'input-additional-hours',
  INPUT_PREVIOUS_HOURS = 'input-previous-hours',
  PATIENT_PRESCRIPTIONS_ALL_TAB_LAYOUT = 'patient-prescriptions-all-tab-layout',
  PATIENT_PRESCRIPTIONS_ALL_TAB_PANEL = 'patient-prescriptions-all-tab-panel',
}
export { PatientPrescriptionsAllTabAliases };
